import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import "../historyDetail.scss";

interface Props {
    setShowDetails: any;
    details: any;
    activityType: string;
}

interface Details {
    id: string;
    type: any;
    value: any;
    variable: string;
}
export const HistoricalActivitiesDetails = ({
    setShowDetails,
    details,
    activityType,
}: Props) => {
    const handleClose = () => {
        setShowDetails(false);
    };

    const [variablesToUpdate, setVariablesToUpdate] = useState<any>(undefined)

    useEffect(() => {
        console.log({ details })
    }, [details])


    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 3,
                }}
            >
                <IconButton
                    aria-label="delete"
                    onClick={handleClose}
                    sx={{
                        backgroundColor: "#03365e",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: "#129ED3",
                        },
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>
            </Box>

            <Box sx={{ mt: 3 }}>
                <Typography variant="h6" color="initial">
                    Actividad Requerida : <strong>{activityType}</strong>
                </Typography>
            </Box>

            <Box className="list_activities_variables">
                <Grid className="variables-list-section">
                    {details?.map((variable: any, index: number) => {
                        if (["Comentario", "Cuadrilla", "Ingenieros"].includes(variable.variable)) return null
                        return (
                            <Grid key={index}>
                                <TextField
                                    id="variable"
                                    size="small"
                                    onChange={(e) => variable?.variableIdToEdit && setVariablesToUpdate({ ...variablesToUpdate, [variable?.variableIdToEdit]: e.target.value })}
                                    label={variable.variable}
                                    value={variablesToUpdate?.[variable?.variableIdToEdit] || variable.value}
                                    fullWidth
                                    sx={{
                                        backgroundColor: variable?.variableIdToEdit ? 'white' : '#f5f5f5',
                                    }}
                                />
                            </Grid>
                        )
                    })}
                </Grid>
                {details?.find((variable: any) => variable.variable === "Comentario") && (
                    <Grid className="comment-section">
                        <Typography variant="subtitle2" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>Comentario</Typography>
                        <Grid className="comment-value">
                            {details?.find((variable: any) => variable.variable === "Comentario")?.value || ""}
                        </Grid>
                    </Grid>
                )}
                {/* {details.map((detail: Details, index: number) => {
                    return (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                mb: 1,
                                p: 1,
                                borderBottom: "1px solid #ddd",
                            }}
                        >
                            <Typography
                                variant="body1"
                                color="textPrimary"
                                sx={{ pr: 2 }}
                            >
                                {detail.variable}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="textSecondary"
                                sx={{ pl: 2 }}
                            >
                                {detail.value}
                            </Typography>
                        </Box>
                    );
                })} */}
            </Box>
        </Box>
    );
};
